import React from 'react';
import { InputCard } from '@components/cards';
import { RADIO } from '@components/cards/input-card/input-card.type';

import { EventChannelViewProps } from './event-channel-view.type';

export const EventChannelView = ({ channels, teams, handleChange, selectedChannelId }: EventChannelViewProps) => {
  const Item = ({ id, name }: { id: string; name: string }) => (
    <InputCard
      isChecked={id === selectedChannelId}
      isDisabled={false}
      type={RADIO}
      handleClick={() => handleChange(id)}>
      <p className='text-primary text-subtitle-m' key={id}>
        {name}
      </p>
    </InputCard>
  );

  return (
    <div className='flex flex-col gap-4 mt-6'>
      <div className='px-4 sm:px-2'>
        {teams?.length
          ? teams.map((team) => (
              <div key={team.id} className='flex flex-col gap-4'>
                <p className='text-primary text-subtitle-l' key={team.id}>
                  {team.name}
                </p>
                {team.channels.map((tChannel) => (
                  <Item key={tChannel.id} id={tChannel.slug} name={tChannel.name} />
                ))}
              </div>
            ))
          : channels?.map((channel) => <Item key={channel.id} id={channel.slug} name={channel.name} />)}
      </div>
    </div>
  );
};
